if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
        };
        this.search = this.querySelector('.localization-form__search-input');
        this.listItems = Array.from(this.querySelectorAll('.disclosure__item'));

        this.onBodyClick = this.onBodyClick.bind(this);
        this.onFocusOut = this.onFocusOut.bind(this);

        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        // Needed now that focus can move into the search input; close when focus leaves the component
        this.addEventListener('focusout', this.onFocusOut);

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));

        if (this.search) {
          this.search.addEventListener('input', this.onSearchInput.bind(this));
          this.search.addEventListener('keydown', (event) => {
            if (event.code?.toUpperCase() === 'ESCAPE') {
              event.preventDefault();
              this.search.value = '';
              this.onSearchInput();
              this.hidePanel();
              this.elements.button.focus();
            }
          });
        }
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
        document.removeEventListener('click', this.onBodyClick);
      }

      onBodyClick(event) {
        if (this.contains(event.target)) return;
        this.hidePanel();
      }

      onFocusOut(event) {
        const next = event.relatedTarget;
        if (next && this.contains(next)) return;
        this.hidePanel();
      }

      onSearchInput() {
        if (!this.search) return;
        const query = this.search.value.trim().toLowerCase();
        this.listItems.forEach((li) => {
          const text = li.textContent ? li.textContent.toLowerCase() : '';
          li.hidden = query.length > 0 && !text.includes(query);
        });
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
        this.hidePanel();
        event.stopPropagation();
        this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );

        // Reset filter on open and focus search for fast switching
        if (!this.elements.panel.hasAttribute('hidden') && this.search) {
          document.addEventListener('click', this.onBodyClick);
          this.search.value = '';
          this.onSearchInput();
          this.search.focus();
        } else {
          document.removeEventListener('click', this.onBodyClick);
        }
      }

      closeSelector(event) {
        const isChild =
          this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
        if (!event.relatedTarget || !isChild) {
          this.hidePanel();
        }
      }
    }
  );
}
